import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { EmployeeTable } from './components';

export default function EmployeesPage() {
  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Helmet>
          <title> Users </title>
        </Helmet>
        <EmployeeTable />
      </QueryClientProvider>
    </>
  );
}
